import styled from "styled-components";

export const Content = styled.div`
  padding-block: 32px;
  padding-inline: 25%; // Aqui altera a largura dos containers
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px; // Espaço entre os elementos internos da div

  display: hidden;
  animation: fadeIn 0.7s ease-in forwards;
  opacity: 0;

  @keyframes fadeIn {
    from {
      display: hidden;
      opacity: 25%;
    }
    to {
      display: flex;
      opacity: 100%;
    }
  }

  background: linear-gradient(
    to top,
    ${({ bgColor }) => {
      // recebe bgColor em hexadecimal e converte pra rgb
      const r = parseInt(bgColor.slice(1, 3), 16);
      const g = parseInt(bgColor.slice(3, 5), 16);
      const b = parseInt(bgColor.slice(5, 7), 16);

      // usa o rgb na função rgba pra colocar opacidade
      return `rgba(${r}, ${g}, ${b}, 0.75)`;
    }},
    ${({ bgColor }) => bgColor}
  );

  #status-payment {
    padding: 32px 40px 64px;

    @media screen and (max-width: 799px) {
      padding: 32px 24px 50px;
    }
  }

  .other-containers {
    padding: 32px 40px;

    @media screen and (max-width: 799px) {
      padding: 28px 20px 35px;
    }
  }

  @media screen and (max-width: 799px) {
    padding-inline: 3%;
    /* gap: 20px; */
  }

  @media screen and (min-width: 800px) and (max-width: 1000px) {
    padding-inline: 15%;
    /* gap: 20px; */
  }

  @media screen and (min-width: 1000px) {
    padding-inline: 20%;
  }
`;

export const Container = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 6.04275px 26.1419px 34.875px rgba(0, 0, 0, 0.04725),
    2.38726px 10.3277px 13px rgba(0, 0, 0, 0.035), 0.522213px 2.25918px 4.625px rgba(0, 0, 0, 0.02275);

  h2 {
    line-height: 120%;
    font-size: 22px;
  }

  @media screen and (max-width: 799px) {
    width: 100%;
    padding-inline: 12px;
  }

  @media screen and (min-width: 800px) {
    width: 100%;
    flex-direction: row;
  }
`;

export const TryAgain = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 12px;
  margin-top: 20px;
`;
